document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.split-sticky');
  if (!sections.length) return;

  const jumpBar = document.querySelector('.jump-bar');
  const siteHeader = document.querySelector('.site-header');

  function readCssPx(el, name) {
    return parseFloat(getComputedStyle(el).getPropertyValue(name)) || 0;
  }

  // Bottom edge of the fixed chrome (header + jump bar) that the aside sits under
  function getStickyOffset(el) {
    if (jumpBar) {
      const jumpBarBottom = jumpBar.getBoundingClientRect().bottom;
      if (jumpBarBottom > 0) return jumpBarBottom;
    }

    if (siteHeader) {
      const headerBottom = siteHeader.getBoundingClientRect().bottom;
      if (headerBottom > 0) return headerBottom;
    }

    return (
      readCssPx(el, '--site-header-offset') + readCssPx(el, '--jump-bar-height')
    );
  }

  function updateSection(section) {
    const rect = section.getBoundingClientRect();
    const offset = getStickyOffset(section);

    // Above the section — natural position at the top of the aside
    if (rect.top > offset) {
      section.classList.remove('is-sticky', 'is-ended');
      return;
    }

    // Past the section — pin the aside to the bottom of the column
    if (rect.bottom <= window.innerHeight) {
      section.classList.remove('is-sticky');
      section.classList.add('is-ended');
      return;
    }

    // Scrolling through the section — fixed to the viewport
    section.classList.add('is-sticky');
    section.classList.remove('is-ended');
  }

  function updateAll() {
    sections.forEach(updateSection);
  }

  let ticking = false;
  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateAll();
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  updateAll();
});
